var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"1400px","height":"400px"},attrs:{"id":_vm.echartParam.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }